import React, { useState, useRef, useEffect, useContext } from 'react'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useHistory } from 'react-router-dom'

import {
    handleRedirectInternal,
    dateTimeFormatFunction,
    currencyFormat,
} from '@/custom/common/components'
import './InvoiceCard.css'

const InvoiceCard = (props) => {
    const [product, setProduct] = useState()
    const history = useHistory()

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])
    return (
        <>
            <div className="invoiceCard">
                {product ? (
                    <>
                        <h3 className="custName">
                            {'Invoice'} #{product.common_invoice}
                        </h3>
                        {product.paid ? (
                            <>
                                <h5>
                                    {'Paid'}:{' '}
                                    <span dir="ltr">
                                        {dateTimeFormatFunction(product.paid_date)}
                                    </span>
                                </h5>
                            </>
                        ) : (
                            <>
                                <h5>
                                    {'Created'}:{' '}
                                    <span dir="ltr">
                                        {dateTimeFormatFunction(product.date_added)}
                                    </span>
                                </h5>
                            </>
                        )}
                        <div className="icItems d-flex justify-content-between align-items-center">
                            <span>{'Total items'}:</span> <span>{product.total_items}</span>
                        </div>
                        <div className="icPaid d-flex justify-content-between align-items-center">
                            <span>{'Amount'}:</span>{' '}
                            <span>{currencyFormat(product.total_amount)}</span>
                        </div>

                        <div className="icPaid d-flex justify-content-between align-items-center">
                            <span>{'Payment status'}:</span>{' '}
                            <span>
                                {product.payment_method === 'offline' ? 'Offline' : 'Online'}
                            </span>
                        </div>

                        {product.partial === 1 && product.payment_method !== 'offline' ? (
                            <>
                                <PrimaryButton
                                    id="pay_invoice"
                                    label={'Pay invoice'}
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            `checkout/invoice/${product.common_invoice}`,
                                        )
                                    }
                                    btnSize="small"
                                />
                                <PrimaryButton
                                    id="view_invoice"
                                    label={'View invoice'}
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            `invoice/${product.common_invoice}`,
                                        )
                                    }
                                    btnSize="small"
                                />
                            </>
                        ) : (
                            <PrimaryButton
                                id="view_invoice_card"
                                label={'View invoice'}
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        `invoice/${product.common_invoice}`,
                                    )
                                }
                                btnSize="small"
                            />
                        )}
                        {product.delivery_type === 'local_pickup' ? (
                            product.status !== 'no_show' ? (
                                <PrimaryButton
                                    label={
                                        product.appointment_id > 0
                                            ? 'Reschedule Appointment'
                                            : 'Book Appointment'
                                    }
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            `appointment/schedule/${product.common_invoice}`,
                                        )
                                    }
                                    btnSize="small"
                                />
                            ) : null
                        ) : null}
                    </>
                ) : null}
            </div>
        </>
    )
}

export default InvoiceCard
